import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Home from './home';
import NotFound from 'src/common/components/NotFound';
import MusicVideo from './music-video';

export default function Router() {
  return (
    <HashRouter>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/music-video" component={MusicVideo} />
        <Route component={NotFound} />
      </Switch>
    </HashRouter>
  );
}
